import { ActionListControl } from "@certn/forms/src/controls/ActionListControl";
import { ArrayControlProps } from "@jsonforms/core";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../../../../forms/src/CascadiaJsonFormContext";
import { getItemList } from "../../../../forms/src/controls/utils";
import { dataToFile } from "../../utils";

function asString(arrayOrString: any) {
  return Array.isArray(arrayOrString) ? arrayOrString[0] : arrayOrString;
}

export function EducationDocumentsControl(props: ArrayControlProps) {
  const { values: rootValues } = useContext(CascadiaJsonFormContext);
  const { rootSchema } = props;

  const qualificationTitles = Object.fromEntries(
    (
      rootSchema as any
    )?.properties?.education_history?.properties?.educations?.items?.properties?.qualification?.oneOf?.map(
      ({ const: const_, title }: any) => [const_, title]
    ) || []
  ) as { [key: string]: string };

  const educationSummaries = (
    rootValues?.education_history?.educations || []
  ).map(
    ({ institution: { name: institutionName }, qualification }: any) =>
      `${institutionName} - ${qualificationTitles[qualification]}`
  ) as string[];

  function _getItemList(
    labels: string[],
    data: Record<string, unknown>
  ): string[] {
    if (labels?.length === 1) {
      if (labels[0] === "education_idx") {
        return [educationSummaries[Number(data["education_idx"])]];
      } else if (labels[0] === "education_document") {
        return [dataToFile(asString(data["education_document"]))?.name || ""];
      } else if (labels[0].includes("[[education_idx]]")) {
        return getItemList(
          [
            labels[0].replace(
              "[[education_idx]]",
              educationSummaries[Number(data["education_idx"])]
            ),
          ],
          data
        );
      }
    }
    return getItemList(labels, data);
  }

  async function _onItemChanged(
    parentValues: object[],
    values: { education_document?: string },
    index: number
  ): Promise<Record<string, any> | undefined> {
    // Work around the fact that FileUpload ignores required
    if (!values.education_document) {
      return {};
    }
  }

  return (
    <ActionListControl
      {...props}
      getItemList={_getItemList}
      onItemChanged={_onItemChanged}
    />
  );
}
